"use strict";
// Count-based (not boolean) so rapid back-to-back searches each get their
// own arm/disarm pair. Safety timeout force-resets the count in case `idle`
// never fires (e.g. panTo to current position is a no-op).
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetCitySettle = exports.disarmCitySettle = exports.armCitySettle = exports.isCitySettlePending = void 0;
let pendingCount = 0;
let timeoutId = null;
const CITY_SETTLE_TIMEOUT_MS = 10000;
const clearTimer = () => {
    if (timeoutId !== null) {
        clearTimeout(timeoutId);
        timeoutId = null;
    }
};
const isCitySettlePending = () => pendingCount > 0;
exports.isCitySettlePending = isCitySettlePending;
const armCitySettle = () => {
    pendingCount += 1;
    clearTimer();
    timeoutId = setTimeout(() => {
        pendingCount = 0;
        timeoutId = null;
    }, CITY_SETTLE_TIMEOUT_MS);
};
exports.armCitySettle = armCitySettle;
const disarmCitySettle = () => {
    pendingCount = Math.max(0, pendingCount - 1);
    if (pendingCount === 0) {
        clearTimer();
    }
};
exports.disarmCitySettle = disarmCitySettle;
const resetCitySettle = () => {
    pendingCount = 0;
    clearTimer();
};
exports.resetCitySettle = resetCitySettle;
